import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  Form,
  FormControl,
  Pagination,
  Row,
} from "react-bootstrap";
import { dashboard_vertical_three_dots } from "../../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../../services/apiConfig";
import axiosInstance from "../../../services/axios.instance";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse, Invoice } from "../../../types";
import "./RecollectedOrder.css";

const RecollectedOrder = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("access_token");

  // const decodeToken = (token: any) => {
  //   return JSON.parse(atob(token.split(".")[1]));
  // };

  const decodeToken = (token: any) => {
    if (token) {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      return decoded;
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);
  const merchantId =
    decodedToken && decodedToken["merchant-id"]
      ? decodedToken["merchant-id"]
      : null;

  const roles =
    decodedToken && decodedToken["roles"] ? decodedToken["roles"] : null;
  const showBranchColumn = roles?.includes("ROLE_MERCHANT_OPERATION");

  const [currentPage, setCurrentPage] = useState(0);
  const [currentSearchPage, setCurrentSearchPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("");
  const [searchResults, setSearchResults] = useState<ApiResponse | null>(null);
  const [insuranceFilter, setInsuranceFilter] = useState<string>("");
  const generatePageNumbers = (currentPage: number, totalPages: number) => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }

    if (currentPage <= 3) {
      return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
    }

    if (currentPage >= totalPages - 4) {
      return [
        0,
        1,
        -1,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
      ];
    }

    return [
      0,
      1,
      -1,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      -1,
      totalPages - 1,
    ];
  };

  const fetchDeliveredOrders = async (page: number) => {
    let url = `${API_URL.PURCHASE_ORDER}/${merchantId}?status=RECOLLECTED&page=${page}`;

    if (insuranceFilter === "insurance") {
      url += "&insurance-order=true";
    } else if (insuranceFilter === "non_insurance") {
      url += "&insurance-order=false";
    }

    const response = await axiosInstance.get(url);
    return response?.data;
  };
  const { data: DeliveredOrders } = useQuery<ApiResponse>({
    queryKey: ["DeliveredOrders", currentPage, insuranceFilter],
    queryFn: () => fetchDeliveredOrders(currentPage),
    //refetchInterval: 30000,
  });

  const fetchBranches = async () => {
    const response = await axiosInstance.get(
      `${API_URL.CHILD_BRANCHES}?merchantId=${merchantId}`
    );

    return response?.data || [];
  };
  const { data: branches } = useQuery<any>({
    queryKey: ["Branches"],
    queryFn: fetchBranches,
  });
  //----------------------------------------------------------
  const [visiblePages, setVisiblePages] = useState<number[]>(() => {
    const totalPages = DeliveredOrders?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    const totalPages = DeliveredOrders?.totalPages || 0;
    setVisiblePages(generatePageNumbers(page, totalPages));
  };
  useEffect(() => {
    if (DeliveredOrders?.totalPages) {
      setVisiblePages(
        generatePageNumbers(currentPage, DeliveredOrders.totalPages)
      );
    }
  }, [DeliveredOrders, currentPage]);

  //==========================================

  // const handlePageChange = (page: number) => {
  //   setCurrentPage(page);
  // };
  // const handlePageSearchChange = (page: number) => {
  //   setCurrentSearchPage(page);
  //   handleSearch(page);
  // };

  //--------------------------------------------------------------------------

  const [searchVisiblePages, setSearchVisiblePages] = useState<number[]>(() => {
    const totalPages = searchResults?.totalPages || 0;
    return generatePageNumbers(0, totalPages);
  });

  //-----------------------

  useEffect(() => {
    if (searchResults?.totalPages) {
      setSearchVisiblePages(
        generatePageNumbers(currentSearchPage, searchResults.totalPages)
      );
    }
  }, [searchResults, currentSearchPage]);

  // const handleSearchPageChange = (page: number) => {
  //   setSearchPage(page);
  // };
  const handlePageSearchChange = (page: number) => {
    setCurrentSearchPage(page);
    handleSearch(page);
  };
  //--------------------------------------------------------------------------------

  const handleSearch = async (currentSearchPage: number) => {
    setCurrentPage(0);
    // const date_filter_key = searchCriteria.toLowerCase().replace(" ", "_");
    let date_filter_key = "";
    if (searchCriteria === "recollection_date") {
      date_filter_key = searchCriteria.toLowerCase().replace(" ", "_");
    }

    const payload = {
      order_number: searchCriteria === "order_number" ? searchQuery : "",
      date_filter_key: date_filter_key,
      date: searchCriteria === "recollection_date" ? searchQuery : "",
      insurance_claim: searchCriteria === "insurance_claim" ? searchQuery : "",
      erp_service_number:
        searchCriteria === "erp_service_number" ? searchQuery : "",
      customer_name: searchCriteria === "customer_name" ? searchQuery : "",
      customer_phone_number:
        searchCriteria === "customer_phone_number" ? searchQuery : "",
      merchant_id: searchCriteria === "merchant_id" ? searchQuery : "",
      count: 10,
      page: currentSearchPage,
      order_status_in: ["RECOLLECTED"],
    };

    // const response = await axiosInstance.post(API_URL.SEARCH_RESULTS, payload);
    // setSearchResults(response.data);
    try {
      const response = await axiosInstance.post(
        API_URL.SEARCH_RESULTS,
        payload
      );
      setSearchResults(response.data);
    } catch (error) {
      console.error("Error fetching search results", error);
    }
  };
  const formatDate = (isoDate: any) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };
  const handleSearchCriteriaChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSearchCriteria(e.target.value);
    // setSearchQuery("");
  };

  const ordersToDisplay = searchResults?.content || DeliveredOrders?.content;
  const navigateToExportStatus = () => {
    navigate("/merchant/exportAllStatus");
  };

  return (
    <div className="row">
      <div className="col-md-12 mb-3 mt-2">
        <Form.Group as={Row} className="align-items-center">
          <Col sm="3">
            <Form.Select
              className="custom-select"
              aria-label="Select search criteria"
              value={searchCriteria}
              onChange={handleSearchCriteriaChange}
            >
              <option value="">Search by</option>
              <option value="order_number">Order Number</option>
              <option value="recollection_date">Date</option>
              <option value="insurance_claim">Insurance Claim</option>
              <option value="erp_service_number">LPO Number</option>
              <option value="customer_name">Customer Name</option>
              <option value="customer_phone_number">Phone Number</option>
              <option value="merchant_id">Branch</option>
            </Form.Select>
          </Col>
          {!searchCriteria && (
            <Col sm="3">
              <Form.Select
                className="custom-select"
                value={insuranceFilter}
                onChange={(e) => {
                  setInsuranceFilter(e.target.value);
                  setSearchResults(null);
                  setCurrentPage(0);
                }}
              >
                <option value="">All Orders</option>
                <option value="insurance">AAA</option>
                <option value="non_insurance">KIRKOS</option>
              </Form.Select>
            </Col>
          )}
          {searchCriteria && (
            <>
              <Col sm="5">
                {searchCriteria === "merchant_id" ? (
                  <Form.Select
                    className="custom-select"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  >
                    <option value="">Select Branch</option>
                    {branches?.map((branch: any) => (
                      <option
                        key={branch?.merchant_id}
                        value={branch?.merchant_id}
                      >
                        {branch?.business_name}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  <FormControl
                    className="search-bar"
                    aria-label="Text input with select"
                    placeholder={
                      searchCriteria === "recollection_date"
                        ? "DD-MM-YYYY"
                        : "Enter your Search"
                    }
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                )}
              </Col>

              <Col sm="2">
                <Button
                  className="search-button"
                  onClick={() => handleSearch(currentSearchPage)}
                >
                  Search
                </Button>
              </Col>
            </>
          )}
        </Form.Group>
      </div>
      <Row className="justify-content-end">
        <Col sm="2">
          <Button
            variant="primary"
            className="btn all_button_style text-black my-1 w-100"
            onClick={navigateToExportStatus}
          >
            Export
          </Button>
        </Col>
      </Row>
      <div className="col-md-12 dashboard-table-div">
        <table className="table table-hover dashboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Order Number</th>
              {showBranchColumn && <th>Branch</th>}
              <th>Number of Days</th>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Product Name</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {ordersToDisplay?.map((invoice: Invoice, index: number) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{invoice?.orderId}</td>
                {showBranchColumn && <td>{invoice?.merchantName}</td>}
                <td>{invoice?.rental_days}</td>
                <td>{invoice?.customer_name}</td>
                <td>{invoice?.customer_phone_number}</td>
                <td>{invoice?.products?.[0]?.productName}</td>
                <td>
                  <span className="invoice-date-td">
                    {formatDate(invoice?.recollection_date)}
                  </span>
                </td>

                <td>
                  {" "}
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="Dropdown-table"
                    >
                      <img
                        src={dashboard_vertical_three_dots}
                        width="15"
                        height="15"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="Dropdown-table-item">
                      <Dropdown.Item className="Dropdown-table-list Dropdown-table-border-bottom">
                        <Link
                          to={`/merchant/recollected/details?OrderId=${invoice.orderId}`}
                          className="nav-link Dropdown-table-item-link"
                        // onClick={() => handleOrderDetails(invoice.orderId)}
                        >
                          View Details
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item className="Dropdown-table-list Dropdown-table-border-bottom">
                        <Link
                          to={`/merchant/vdrEdit?OrderId=${invoice.orderId}`}
                          className="nav-link Dropdown-table-item-link"
                        // onClick={() => handleOrderDetails(invoice.orderId)}
                        >
                          Vdr Edit
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {searchResults === null && DeliveredOrders ? (
          <Pagination className="pagination-align">
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 0}
            />
            {visiblePages.map((pageNum, index) =>
              pageNum === -1 ? (
                <Pagination.Ellipsis key={`ellipsis_${index}`} />
              ) : (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentPage}
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum + 1}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === (DeliveredOrders?.totalPages || 0) - 1}
            />
          </Pagination>
        ) : searchResults ? (
          <Pagination className="pagination-align">
            <Pagination.Prev
              onClick={() => handlePageSearchChange(currentSearchPage - 1)}
              disabled={currentSearchPage === 0}
            />
            {searchVisiblePages.map((pageNum, index) =>
              pageNum === -1 ? (
                <Pagination.Ellipsis key={`ellipsis_${index}`} />
              ) : (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentSearchPage}
                  onClick={() => handlePageSearchChange(pageNum)}
                >
                  {pageNum + 1}
                </Pagination.Item>
              )
            )}
            <Pagination.Next
              onClick={() => handlePageSearchChange(currentSearchPage + 1)}
              disabled={
                currentSearchPage === (searchResults?.totalPages || 0) - 1
              }
            />
          </Pagination>
        ) : null}
      </div>
    </div>
  );
};

export default RecollectedOrder;
